import { toastAlert } from "../../utils/AlertContext";
import { clippingErrorAlert } from "../../utils/clippingErrorAlert";
import { postGenerateClippingURL } from "../../utils/ConstantsURL";

const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };

    reader.onerror = reject;
  });
};

export const useGenerateClipping = (token, addToDownloadQueue) => {
  const base64ToBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteNumbers = Array.from(byteCharacters).map((c) =>
      c.charCodeAt(0)
    );
    return new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
  };

  const generateClipping = async (body) => {
    toastAlert("Generando clipping...", "info");

    try {
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let requestBody = { ...body };

      if (body.coverFile) {
        const base64 = await fileToBase64(body.coverFile);

        requestBody.coverBase64 = base64;
        delete requestBody.coverFile;
      }

      requestBody = JSON.stringify(requestBody);

      const response = await fetch(postGenerateClippingURL(), {
        method: "POST",
        headers,
        body: requestBody,
      });

      if (!response.ok) throw new Error("Error al generar clipping");

      const data = await response.json();
      const { content, filename, mimeType } = data.document;

      const blob = base64ToBlob(content, mimeType);
      const url = URL.createObjectURL(blob);

      addToDownloadQueue({
        nameDocument: filename,
        fecha: new Date().toLocaleDateString("en-GB"),
        generatedAt: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        url,
      });

      toastAlert("Clipping generado y añadido a la cola", "success");
    } catch (error) {
      toastAlert("Error al generar clipping", "error");
      console.error(error);
      clippingErrorAlert({
        documentName: "Documento por Generación Manual",
        error: error.message,
      });
    }
  };

  return { generateClipping };
};
